// import { Modal } from "./modal";
// import { BalanceBox } from "./objects/balanceBox";
// import { Slider } from "./objects/slider";
// import { WebSocketManager } from "../../helpers/webSocketManager";
// import localScaleManager from "../../helpers/LocalScaleManager";
// import Button from "./objects/button";
// import { Parser } from "../../helpers/parser";
// import { AutoBuyIn } from "./objects/autoBuyIn";
// import { tweenConfigs } from "../../helpers/tweensConfigs";
import { store } from "@/store/store";

// export class AddMoreChipModal extends Modal {
export class AddMoreChipModal {
  /**
   * @param scene {GameScene}
   * @param table {Table}
   * @param balance {number} userBalancex
   */
  constructor(scene, table, balance) {
    // super(scene, table);
    this.scene = scene;
    this.table = table;
    this.tableInfo = table.tableInfo;
    // this.isShowing = false;

    // this.buyInInfo = {
    //   balance: 0,
    //   maxBuyIn: 0,
    //   minBuyIn: 0,
    //   autoRebuy: false,
    //   canBuyIn: false,
    //   rebuyAt: 1,
    //   message: "",
    // };
    // this.bg = this.scene.add.sprite(0, 0, this.scene.atlasTexture, 'add-more-chip-modal-bg').setOrigin(0);
    // this.bg = this.scene.add
    //   .sprite(0, 0, this.scene.atlasTexture, "add-more-chip-modal-bg")
    //   .setOrigin(0);
    // this.bg.on("pointerdown", this.blurTextInput, this);

    // this.sliderValueText = this.scene.add.bitmapText(
    //   0,
    //   0,
    //   "myRaid",
    //   "123456789135464797"
    // );
    // this.sliderValueText.setData("width", this.sliderValueText.width);
    // this.sliderValueText.setData("height", this.sliderValueText.height);
    // this.sliderValueText.setInteractive();
    // this.sliderValueText.on(
    //   "pointerdown",
    //   this.onPointerDownOnSliderValueText,
    //   this
    // );

    // this.sliderValueInput = this.scene.add
    //   .rexInputText(0, 0, 0, 0, {
    //     id: "sliderValueInput",
    //     type: "number",
    //     text: 0,
    //     fontSize: "10px",
    //     // backgroundColor: 'white',
    //     // color: 'black',
    //     color: "white",
    //     fontFamily: "myRaid",
    //     align: "center",
    //   })
    //   .on("textchange", (inputText, e) => {
    //     this.slider.changeValue(e.target.value);
    //   })
    //   .on("focus", (inputText, e) => {
    //     inputText.text = Parser.decodeAmount(e.target.value);
    //   })
    //   .setVisible(false);
    // this.addStyleForRemoveNumberInputArrows();

    // this.balanceBox = new BalanceBox(this.scene, this.buyInInfo.balance);
    // this.autoBuyIn = new AutoBuyIn(this.scene);

    // this.button = this.scene.add.image(0, 0, this.scene.atlasTexture, 'reserve-modal-btn').setOrigin(0);
    // this.button = new Button(this.scene, "reserve-modal-btn", true, this.table);
    // this.button.on("pointerup", this.doConfirm, this); //D
    // this.slider = new Slider(
    //   scene,
    //   this,
    //   this.buyInInfo.maxBuyIn,
    //   this.buyInInfo.minBuyIn
    // );
    // this.children = this.scene.add.group();
    // this.children.addMultiple([
    //   this.bg,
    //   this.closeButton,
    //   this.sliderValueInput,
    //   this.sliderValueText,
    //   ...this.slider.children.getChildren(),
    //   ...this.balanceBox.children.getChildren(),
    //   ...this.autoBuyIn.children.getChildren(),
    //   this.button,
    // ]);
    // Phaser.Actions.SetDepth(this.children.getChildren(), 121);
    // this.children.getChildren()[1].setDepth(122); /* close button */
    // Phaser.Actions.SetAlpha(this.children.getChildren(), 0);
    // this.closeButton.on("pointerup", this.leaveTable, this, this.table); //D
    // this.overlay.on("pointerdown", this.blurTextInput, this);
    // this.userClosedModal = false;
    // this.initX = 0;
    // this.tableWidth = 0;
    this.autoShow = false; /* A flag for if player clicked on buy-in icon (false) or modal was showed without clicking (true) */
    // this.showInProgress = false;
  }

  // onPointerDownOnSliderValueText() {
  //   this.sliderValueText.setVisible(false);
  //   this.sliderValueInput.setText(this.buyInValue);
  //   this.sliderValueInput.setVisible(true);
  // }

  // blurTextInput() {
  //   this.sliderValueInput.setVisible(false);
  //   this.sliderValueText.setVisible(true);
  // }
  // changeSliderValueText(amount) {
  //   this.buyInValue = amount;
  //   this.sliderValueText.text = amount.toLocaleString();
  //   this.sliderValueText.setX(
  //     this.initX + (this.tableWidth - this.sliderValueText.width) / 2
  //   );
  // }
  // addStyleForRemoveNumberInputArrows() {
  //   let style = document.createElement("style");
  //   style.innerHTML = `
  //       #sliderValueInput::-webkit-inner-spin-button,
  //       #sliderValueInput::-webkit-outer-spin-button {
  //         -webkit-appearance: none;
  //         margin: 0;
  //       }`;
  //   document.head.appendChild(style);
  // }
  // async doConfirm() {
  //   this.button.onClick(() => {
  //     this.button.disableInteractive();
  //     const url = this.autoShow
  //       ? "poker.client-push.join-table"
  //       : "poker.client-push.rebuy";
  //     const dataToServer = this.autoShow
  //       ? {
  //           tableId: this.table.tableInfo.id,
  //           clubId: this.scene.getURLClubId(),
  //           buyIn: this.buyInValue,
  //           autoRebuy: this.autoBuyIn.checkBoxValue,
  //           rebuyAt: this.autoBuyIn.checkBoxValue
  //             ? this.autoBuyIn.inputValue
  //             : 1,
  //         }
  //       : {
  //           tableId: this.table.tableInfo.id,
  //           clubId: this.scene.getURLClubId(),
  //           balance: this.buyInValue,
  //           autoRebuy: this.autoBuyIn.checkBoxValue,
  //           rebuyAt: this.autoBuyIn.checkBoxValue
  //             ? this.autoBuyIn.inputValue
  //             : 1,
  //         };
  //     WebSocketManager.emitEvent(dataToServer, url)
  //       .then(() => {
  //         this.hide().then(() => {
  //           this.button.enableInteractive();
  //         });
  //       })
  //       .catch((e) => {
  //         this.button.enableInteractive();
  //         console.error(e);
  //       });
  //   });
  // }
  showAddMoreChipModal(autoShow, table) {
    store.commit("setAddMoreChipsModalShow", true);
    store.commit("setAddMoreChipsAutoShow", autoShow);
    store.commit("setTableInfo", table);
    this.scene.changeObjectsInteractivity(false);
  }

  /**
   * @param table{Table}
   * @param autoShow{boolean} A flag for if player clicked on buy-in icon (false) or modal was showed without clicking (true)
   */
  async show(table, autoShow = false) {
    // this.showInProgress = true;
    this.autoShow = autoShow;
    // this.button.enableInteractive();
    // if (this.isShowing) {
    //   await this.hide();
    // }
    /* hengam nemayesh modal bayad hatmn aval table ra update konim */
    // await this.pullTableBuyIn(table);
    this.table = table;
    // if (!this.buyInInfo.canBuyIn) {
    //   if (this.scene.getVisitedTable() === this.table) {
    //     this.scene.alertify.typeError(this.buyInInfo.message);
    //   }
    // } else {
      // if (this.buyInInfo.maxBuyIn > 0) {
      // this.updateInfo();
      // this.positionControls(
      //   table.displayWidth,
      //   table.displayHeight,
      //   table.x,
      //   table.y
      // );
      // this.blurTextInput();
      // this.autoBuyIn.init();
      // const childrenToShow = [
      //   this.bg,
      //   this.closeButton,
      //   this.sliderValueInput,
      //   this.sliderValueText,
      //   ...this.slider.children.getChildren(),
      //   ...this.balanceBox.children.getChildren(),
      //   this.autoBuyIn.cover,
      //   this.button,
      // ];
      // this.scene.tweens.add({
      //   targets: childrenToShow,
      //   // delay: 200,
      //   duration: tweenConfigs.modal.show.duration,
      //   ease: tweenConfigs.modal.show.ease,
      //   alpha: 1,
      //   onComplete: () => {
      //     this.isShowing = true;
      //     this.showInProgress = false;
      //     if (this.buyInInfo.autoRebuy) {
      //       this.autoBuyIn.inputValue = this.buyInInfo.rebuyAt;
      //       this.autoBuyIn.input.setText(this.buyInInfo.rebuyAt);
      //       this.autoBuyIn.visibilityControls(true);
      //     } else {
      //       this.autoBuyIn.visibilityControls(false);
      //     }
      //     this.autoBuyIn.input.setAlpha(1);
      //   },
      // });
      // this.modalShow();
      this.showAddMoreChipModal(this.autoShow, table);
    // }
  }

  hide() {
    // return new Promise((resolve) => {
    // this.scene.tweens.add({
    //   targets: this.children.getChildren(),
    //   duration: tweenConfigs.modal.hide.duration,
    //   ease: tweenConfigs.modal.hide.ease,
    //   alpha: 0,
    //   onComplete: () => {
    //     this.isShowing = false;
    //     resolve();
    //   },
    // });
    // this.modalHide();
    store.commit("setAddMoreChipsModalShow", false);
    // });
    this.scene.changeObjectsInteractivity(true);
    this.autoShow = false;
  }

  // updateInfo() {
  //   this.slider.changeLimits(this.buyInInfo.maxBuyIn, this.buyInInfo.minBuyIn);
  //   this.balanceBox.changeBalance(this.buyInInfo.balance);
  // }
  // async leaveTable() {
  //   this.userClosedModal = true;
  // if (
  //   this.table.gameState.playerInfo &&
  //   this.table.gameState.playerInfo.state === "SitOut" &&
  //   this.ta ble.gameState.playerInfo.balance === 0
  // ) {
  //   this.closeButton.disableInteractive();
  //   try {
  //     await WebSocketManager.emitEvent(
  //       {
  //         tableId: this.table.tableInfo.id,
  //       },
  //       "poker.client-push.leave"
  //     );
  //     this.hide().then(() => {
  //       this.closeButton.enableInteractive();
  //     });
  //   } catch (e) {
  //     this.hide().then(() => {
  //       this.closeButton.enableInteractive();
  //     });
  //     console.error(e);
  //   }
  // } else {
  // this.hide();

  // }
  // }
  // async pullTableBuyIn(table) {
  //   const url = this.autoShow
  //     ? "poker.client-pull.table-add-chip"
  //     : "poker.client-pull.table-re-buy";
  //   try {
  //     this.buyInInfo = await WebSocketManager.emitEvent(
  //       {
  //         tableId: table.tableInfo.id,
  //         clubId: table.gameState.playerInfo.clubId
  //       },
  //       url
  //     );
  //     store.commit("setBuyInInfo", this.buyInInfo);
  //     // if(!this.autoShow) this.buyInInfo.minBuyIn = 1;
  //   } catch (e) {
  //     console.error(e);
  //   }
  // }

  /***
   * @param width {number} width of table
   * @param height {number} width of table
   * @param initX {number} table top left x
   * @param initY {number} table top left y
   */
  // positionControls(width, height, initX, initY) {
  //   this.initX = initX;
  //   this.tableWidth = width;
  //   const bgSize = width;
  //   const bgScale = localScaleManager.scaleSprite(
  //     this.bg,
  //     bgSize,
  //     bgSize,
  //     0,
  //     1,
  //     true
  //   );
  //   localScaleManager.scaleSpriteTo(this.bg, bgScale);
  //   this.bg.setPosition(
  //     initX + (width - this.bg.displayWidth) / 2,
  //     initY + (height - this.bg.displayHeight) / 2
  //   );

  //   localScaleManager.scaleBitMapText(
  //     this.sliderValueText,
  //     width / 2,
  //     height / 16,
  //     Math.min(this.sliderValueText.width, this.sliderValueText.height) * 0.2,
  //     1,
  //     false
  //   );
  //   this.sliderValueText.setPosition(
  //     initX + (width - this.sliderValueText.width) / 2,
  //     initY + height / 2.8
  //   );

  //   this.sliderValueInput.resize(
  //     this.bg.displayWidth / 1.5,
  //     this.bg.displayWidth / 10
  //   );
  //   this.sliderValueInput.setStyle("fontSize", `${(width / 7) * 0.35}px`);
  //   this.sliderValueInput.setPosition(
  //     initX + this.bg.displayWidth / 2.5,
  //     initY + height / 2.85
  //   );
  //   this.slider.positionControls(
  //     width / 12,
  //     width / 2,
  //     initX + width / 2,
  //     initY + height / 2.3,
  //     width / 2,
  //     height / 50
  //   );
  //   this.balanceBox.positionControls(width, height, initX, initY);
  //   this.autoBuyIn.positionControls(
  //     this.bg.displayWidth,
  //     this.bg.displayHeight,
  //     this.bg.x,
  //     this.bg.y
  //   );
  //   this.modalPositionControls(this.bg.x, this.bg.y, this.bg.displayWidth);

  //   const btnSize = width / 2.5;
  //   const btnScale = localScaleManager.scaleSprite(
  //     this.button,
  //     btnSize,
  //     btnSize,
  //     0,
  //     1,
  //     true
  //   );
  //   localScaleManager.scaleSpriteTo(this.button, btnScale);
  //   this.button.setPosition(
  //     initX + width / 2,
  //     this.bg.y + this.bg.displayHeight - this.button.displayHeight / 1.1
  //   );
  // }
}
